var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.51953C0 2.75811 2.23858 0.519531 5 0.519531C6.32608 0.519531 7.59785 1.04632 8.53553 1.984C9.47322 2.92168 10 4.19345 10 5.51953C10 8.28095 7.76142 10.5195 5 10.5195C2.23858 10.5195 0 8.28095 0 5.51953ZM4.50009 7.02279C4.63341 7.02279 4.76121 6.96955 4.85509 6.87489L6.85509 4.87489C7.05115 4.67883 7.05115 4.36095 6.85509 4.16489C6.65903 3.96883 6.34115 3.96883 6.14509 4.16489L4.50009 5.81489L3.85509 5.16489C3.65903 4.96883 3.34115 4.96883 3.14509 5.16489C2.94903 5.36095 2.94903 5.67883 3.14509 5.87489L4.14509 6.87489C4.23898 6.96955 4.36677 7.02279 4.50009 7.02279Z",
    fill: "#409F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/valid.56fd81f9bb1ea73ab8d1c3b07cbc88a7.svg";
export { ForwardRef as ReactComponent };